import { Avatar, SxProps, Theme } from "@mui/material";
import { useImageUrl } from "hooks/useImageUrl";

export function ImageAvatar({
  displayImg,
  firstName,
  sx,
}: {
  displayImg?: string;
  firstName: string;
  sx?: SxProps<Theme>;
}) {
  const { data: imageUrl, isLoading } = useImageUrl(displayImg);

  const initial = firstName?.charAt(0)?.toUpperCase() || "?";

  return (
    <Avatar
      src={isLoading ? undefined : imageUrl || undefined}
      alt={firstName}
      sx={{
        bgcolor: "primary.main",
        color: "#fff",
        fontSize: "inherit",
        fontWeight: 600,
        ...sx,
      }}
    >
      {initial}
    </Avatar>
  );
}
